module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "textcenter"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm06_dedi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("To Mom and Dad:"), _c('br'), _vm._v("Your love, challenge, encouragement,"), _c('br'), _vm._v("and prayers have marked me and"), _c('br'), _vm._v("my leadership forever."), _c('br'), _vm._v("Thank you!"), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13106f3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm06_dedi.vue
// module id = 72
// module chunks = 0